module.exports = __webpack_public_path__ + "static/media/twitter-logo.66d84390.svg";